<template>
  <div>
    <StepHeader
      :title="stepTitle"
    />

    <StepContent
      width="lg"
    >
      <AppInput
        v-for="(field, index) in fields"
        :key="index"
        :label="field.label"
        :name="field.name"
        :error="field.error"
        :value="field.value"
        v-data-layer
        :data-layer="`${field.name}_field`"
        @input="handleInput(field.name, $event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer="handleDataLayer"
        @click="handleContinue()"
      >
        Continue to Final Step
      </AppButtonContinue>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppInput from '../inputs/AppInput'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import validation from '@/mixins/validation'
import StepHeader from '@/components/common/step/StepHeader'
import DataLayer from '../../../../data-layer'

export default {
  // Name
  name: 'name-details',

  // Components
  components: {
    AppButtonContinue,
    AppInput,
    StepContent,
    StepFooter,
    StepHeader
  },

  // Mixins
  mixins: [validation],

  // Data
  data () {
    return {
      datalayerStepName: 'name',
      submitted: false,
      errors: {
        isRequired: 'This field is required.',
        minCharacters: 'Please enter at least 2 characters.'
      },
      stepTitle: `Almost Done\nWhat Is Your Name?`
    }
  },

  // Computed
  computed: {
    fields () {
      return [{
        label: 'First Name',
        name: 'first_name',
        value: this.firstName,
        error: this.firstNameError
      }, {
        label: 'Last Name',
        name: 'last_name',
        value: this.lastName,
        error: this.lastNameError
      }]
    },

    firstName () {
      return this.$store.state.application.first_name
    },

    firstNameError () {
      if (!this.submitted) return
      if (!this.firstName) return this.errors.isRequired
      if (this.firstName.trim().length < 2) return this.errors.minCharacters
    },

    lastName () {
      return this.$store.state.application.last_name
    },

    lastNameError () {
      if (!this.submitted) return
      if (!this.lastName) return this.errors.isRequired
      if (this.lastName.trim().length < 2) return this.errors.minCharacters
    },

    stepIsValid () {
      return !this.firstNameError && !this.lastNameError
    }
  },

  // Methods
  methods: {
    /**
     * Handle Input
     * Update the store
     */
    handleInput (field, value) {
      this.$store.updateApplication(field, value)
    },

    /**
     * Handle Continue
     * @emits next
     */
    handleContinue () {
      this.submitted = true
      if (this.stepIsValid) this.$emit('next')
    },

    handleDataLayer () {
      const {
        dob_day: dobDay,
        dob_month: dobMonth,
        dob_year: dobYear
      } = this.$store.state.application
      DataLayer.track({
        event: 'gpa_step_completed',
        step: '15'
      })
      DataLayer.identify({
        name: `${this.firstName} ${this.lastName}`,
        birthdate: `${dobMonth}/${dobDay}/${dobYear}`
      })
    }
  }
}
</script>

<style scoped lang="scss">
.step-header {
  @include breakpoint('desktop-up') {
    padding-bottom: 0;
  }
}
</style>
